import { render, staticRenderFns } from "./inputmoney.vue?vue&type=template&id=88f279ae"
import script from "./inputmoney.js?vue&type=script&lang=js&external"
export * from "./inputmoney.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports